/** Start the first row's image requests before a product section reaches the viewport. */
class ProductListImages extends HTMLElement {
  #observer;

  connectedCallback() {
    if (!('IntersectionObserver' in window)) return;
    this.#observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      const columns = window.matchMedia('(max-width: 749px)').matches
        ? Number(this.dataset.mobileColumns)
        : Number(this.dataset.columns);
      const images = this.querySelectorAll('.bz-card__image');
      // Include the partially visible next card in carousel layouts.
      const count = Math.max(1, columns || 4) + 1;
      for (const image of Array.from(images).slice(0, count)) {
        image.loading = 'eager';
      }
      this.#observer.disconnect();
    }, { rootMargin: '1200px 0px' });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('product-list-images')) {
  customElements.define('product-list-images', ProductListImages);
}
